/**
 * Collection Filters
 * 
 * @module collection-filters
 * @version 1.0.0
 * @extends HTMLElement
 */
class CollectionFilters extends HTMLElement {

    /**
     * Collection filters web component.
     * 
     * @constructor
     */
    constructor() {

      super();

      // This variable is used to store data as cache
      this.filterData = [];
      
      this.initEvents();

      this.renderCounts();

      this.renderAllSelectedFilters();
    }

    /**
     * Init component events.
     * 
     * @returns {undefined}
     */
    initEvents() {

        if(window.screenMode != 'mobile' ) {
            this.setTop();
        }

        this.removeSizeOutOfStock(window.location.href);
      
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = window.theme.debounce.apply(event => {
            this.onSubmitHandler(event);
        }, 500);
      
        this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    
        window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    /**
     * Scroll the page update
     * @returns {undefined}
     */
    scrollUp(){
        if (document.getElementById('CollectionProductGrid').dataset.scroll == "true") {
            window.scrollTo({ top: 50, behavior: 'smooth' });
            // For Safari
            document.body.scrollTop = 50;
            // For Chrome, Firefox, IE and Opera
            document.documentElement.scrollTop = 50;
        }
    }
    
    /**
     * On submit handler event.
     * 
     * @param {object} event Event.
     * @returns {undefined}
     */
    onSubmitHandler(event) {

      event.preventDefault();

      const formData = new FormData(event.target.closest('form'));

      const searchParams = new URLSearchParams(formData).toString();
      
      this.renderPage(searchParams, event);
    }

    /**
     * On active filter click event.
     * 
     * @param {object} event Click event.
     * @returns {undefined}
     */
    onActiveFilterClick(event) {

        event.preventDefault();
        
        this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
    }

    /**
     * Render page content.
     * 
     * @param {string} searchParams URL params.
     * @param {object} event Click event.
     * @param {boolean} updateURLHash update URL hash.
     * @returns {undefined}
     */
    renderPage(searchParams, event, updateURLHash = true) {

        const sections = this.getSections();
  
        document.getElementById('CollectionProductGrid').classList.add('loading');
    
        sections.forEach((section) => {
          const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}&options%5Bprefix%5D=none&type=product`;
          
          const filterDataUrl = element => element.url === url;
          this.filterData.some(filterDataUrl) ?
            this.renderSectionFromCache(filterDataUrl, event) :
            this.renderSectionFromFetch(url, event);
        });
    
        if (updateURLHash) this.updateURLHash(searchParams);
        this.scrollUp();
    }

    /**
     * Get sections.
     * 
     * @returns {undefined}
     */
    getSections() {
        return [
            {
                id: 'collection',
                section: document.getElementById('main-collection-product-grid').dataset.id,
            }
        ]
    }

    /**
     * Render section from fetch.
     * 
     * @param {string} url String url.
     * @param {object} event Event.
     * @returns {undefined}
     */
    renderSectionFromFetch(url, event) {
        console.log('Fetching URL:', url); // Log da URL
    
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then((responseText) => {
                const html = responseText;
                const html_dom = new DOMParser().parseFromString(html, 'text/html');
    
                this.filterData = [...this.filterData, { html, url }];
    
                this.renderFilters(html_dom, event);
                this.renderProductGrid(html_dom, url);
                this.renderProductCount(html_dom);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    /**
     * Render section from catch.
     * 
     * @param {function} filterDataUrl A function.
     * @param {object} event Event.
     * @returns {undefined}
     */
    renderSectionFromCache(filterDataUrl, event) {

        const html = this.filterData.find(filterDataUrl).html;

        const html_dom = new DOMParser().parseFromString(html, 'text/html');

        this.renderFilters(html_dom, event);

        this.renderProductGrid(html_dom, this.filterData.find(filterDataUrl).url);

        this.renderProductCount(html_dom);
    }

    /**
     * Render product grid.
     * 
     * @param {object} html_dom Page html dom.
     * @returns {undefined}
     */
    renderProductGrid(html_dom, url) {

        let productGrid = document.getElementById('CollectionProductGrid');

        if (productGrid) {

            let newProductGrid = html_dom.getElementById('CollectionProductGrid');

            if (newProductGrid) {
                
                productGrid.innerHTML = newProductGrid.innerHTML;

                this.removeSizeOutOfStock(url);

				document.getElementById('CollectionProductGrid').classList.remove('loading');

                this.renderQuickAddToCartPopup();

                const eventQuickView = new CustomEvent('init-quickview');
                window.dispatchEvent(eventQuickView);

                if(window.innerWidth > 1300 && document.body.clientHeight <= 1300) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    // For Safari
                    document.body.scrollTop = 0;
                    // For Chrome, Firefox, IE and Opera
                    document.documentElement.scrollTop = 0;

                } 
            }
        }
    }

    /**
     * Render product count.
     * 
     * @param {object} html_dom Page html dom.
     * @returns {undefined}
     */
     renderProductCount(html_dom) {

      let productQty = document.querySelectorAll('[data-collection-filter-product-qty]');

      let newproductQty = html_dom.querySelector('[data-collection-product-qty]');

      if(newproductQty){
        productQty.forEach(elem => {
          elem.innerHTML = newproductQty.innerHTML;
        });
      }

  }

    /**
     * Render filters.
     * 
     * @param {object} html_dom Page html dom.
     * @returns {undefined}
     */
    renderFilters(html_dom, event) {

        const facetDetailsElements =
          html_dom.querySelectorAll('#CollectionFiltersForm .js-filter');

		const matchesIndex = element => {

			let result = element.dataset.index === event?.target.closest('.js-filter')?.dataset.index;

			return result;
		}

        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    
        facetsToRender.forEach((element) => {
          document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });
    
        this.renderActiveFacets(html_dom);

        this.renderAdditionalElements(html_dom);
        
        this.renderCounts();

        this.renderAllSelectedFilters();
    }

    /**
     * Render active facets.
     * 
     * @param {object} html_dom Page html dom.
     * @returns {undefined}
     */
    renderActiveFacets(html_dom) {
    
        const activeFacetElementSelectors = ['.active-facets'];

        activeFacetElementSelectors.forEach((selector) => {

            const activeFacetsElement = html_dom.querySelector(selector);

            if (!activeFacetsElement) return;

            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });
    }

    /**
     * Render additional elements.
     * 
     * @param {object} html_dom Page html dom.
     * @returns {undefined}
     */
    renderAdditionalElements(html_dom) {

        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    
        mobileElementSelectors.forEach((selector) => {

          if (!html_dom.querySelector(selector)) return;

          document.querySelector(selector).innerHTML = html_dom.querySelector(selector).innerHTML;

        });
    }

    /**
     * On history change.
     * 
     * @param {object} event Event.
     * @returns {undefined}
     */
    onHistoryChange(event) {

        const searchParams = event.state?.searchParams || '';

        this.renderPage(searchParams, null, false);
    }

    /**
     * Render counts.
     * 
     * @returns {undefined}
     */
    renderCounts() {

        let count = document.getElementById('activeFacetsCount').dataset.count;

        // if(window.screenMode == 'mobile' && window.location.search.includes('sort_by')) {
        //     count = parseInt(count) + 1;
        // }

        const urlParams = new URLSearchParams(window.location.search);
            
        if (urlParams.get("out_of_stock") === "true") {
          count = parseInt(count) + 1;
          let content = `
              <facet-remove>
                  <a href="/" class="active-facets__button">
                      out of stock
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="32" height="32" fill="none" stroke="none"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.26849 8.2685C8.44039 8.09659 8.67355 8.00002 8.91667 8.00002C9.15978 8.00002 9.39294 8.09659 9.56485 8.2685L23.8248 22.5285C23.9967 22.7004 24.0933 22.9336 24.0933 23.1767C24.0933 23.4198 23.9967 23.6529 23.8248 23.8249C23.6529 23.9968 23.4198 24.0933 23.1767 24.0933C22.9335 24.0933 22.7004 23.9968 22.5285 23.8249L8.26849 9.56486C8.09658 9.39296 8 9.1598 8 8.91668C8 8.67357 8.09658 8.44041 8.26849 8.2685Z" stroke="none"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.2686 23.8248C8.09669 23.6529 8.00011 23.4198 8.00011 23.1767C8.00011 22.9335 8.09669 22.7004 8.2686 22.5285L22.5286 8.26849C22.7005 8.09658 22.9336 8 23.1768 8C23.4199 8 23.653 8.09658 23.8249 8.26849C23.9969 8.44039 24.0934 8.67355 24.0934 8.91667C24.0934 9.15978 23.9969 9.39294 23.8249 9.56485L9.56496 23.8248C9.39305 23.9967 9.15989 24.0933 8.91678 24.0933C8.67366 24.0933 8.4405 23.9967 8.2686 23.8248Z" stroke="none"/>
                      </svg>
                  </a>
              </facet-remove>`
          document.getElementById('activeFacetsCount').innerHTML = document.getElementById('activeFacetsCount').innerHTML  + content;
        }

        document.querySelectorAll('[data-filter-count]').forEach(element => {
			element.dataset.filterCount = parseInt(count);
        });
    }

    /**
     * Render all selected filters text.
     * 
     * @returns {undefined}
     */
    renderAllSelectedFilters() {
        var accordionItems = this.querySelectorAll('[data-accordion-item]');

        if(accordionItems) {

            // Load all filters
            accordionItems.forEach((item) => {
                this.updateHeadingText(item);
            });

           // this.updatePriceHeading();
        }
    }

    /**
     * Render all event buttons that open the quick add to cart popup.
     * 
     * @returns {undefined}
     */
    renderQuickAddToCartPopup() {
        const eventQuickAddToCart = new CustomEvent('init-quick-add-to-cart');
        window.dispatchEvent(eventQuickAddToCart);
    }

    /**
     * Update filter heading text.
     * 
     * @param {object} item Accordion Item.
     * @returns {undefined}
     */
    updateHeadingText(item) {

        // SIZE | COLOR | SORTING | PRODUCT TYPE - options
        let heading = item.querySelector('[data-accordion-heading]');
        let tag = heading.querySelector('[data-accordion-selected-filters]');
        let checkboxInputs = item.querySelectorAll('input[type="checkbox"]');
        checkboxInputs = Array.from(checkboxInputs).filter((input) => input.checked);

        if(checkboxInputs.length) {

            let appliedFilters = '';

            // Load all selected filters
            checkboxInputs.forEach((input, index) => {

                let label = item.querySelector(`label[for='${input.id}']`);

                if(tag && label) {

                    if(index == 0) {
                        //Only one filter selected
                        appliedFilters = `: ${label.innerText}`;
                    }
                    else {
                        //More than one filter selected
                        appliedFilters += ` / ${label.innerText}`;
                    }
                }
            });

        }
        else {
            tag.innerText = '';
        }
    }

    /**
     * Update price filter heading text.
     * 
     * @returns {undefined}
     */
    updatePriceHeading() {

        // PRICE options
        let numberInputs = this.querySelectorAll('input[type="number"]');

        if(numberInputs.length) {

            let minInput = numberInputs[0];
            let maxInput = numberInputs[1];

            if(minInput.value && maxInput.value) {

                let item = minInput.closest('[data-accordion-item]');
                let heading = item.querySelector('[data-accordion-heading]');
                let tag = heading.querySelector('[data-accordion-selected-filters]');
                let min = minInput.getAttribute('min');
                let max = maxInput.getAttribute('max');

                if((parseInt(minInput.value) == parseInt(min))&&(parseInt(maxInput.value) == parseInt(max))) {
                    tag.innerText = '';
                } else {
                    tag.innerText = `: ${minInput.value} - ${maxInput.value}`;
                }
            }
        }
    }

    /**
     * Update URL hash.
     * 
     * @returns {undefined}
     */
    updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    /**
     * remove Size Out Of Stock
     * 
     * @returns {undefined}
     */
    removeSizeOutOfStock(url) {
        if(url.includes('size')) {
            let params =  url.split('&');
            let size = params.find( param => param.includes('size') );
            size = size.split('=')[1];

            let grid = document.getElementById('CollectionProductGrid');

            grid.querySelectorAll("product-card").forEach(productCard => {
                window.theme.product.loadProduct(productCard.dataset.handle, true).then(product => {
                    let option = product.variants.find(variant => (variant.option1 ==  size || variant.option2 ==  size  || variant.option3 ==  size) );

                    if(!option.available) {
                        productCard.parentNode.classList.add('hidden');
                    } else if (productCard.parentNode.classList.contains('hidden')) {
                        productCard.parentNode.classList.remove('hidden');
                    }
                });
            });
        }
    }

    /**
     * Set elements on top
     * 
     * @returns {undefined}
     */
     setTop() {
        let collectionFilters = document.querySelector(".collection__filters");
        let collectionBreadcrumbs = document.querySelector(".collection .breadcrumbs");
        let height = 90;
        
        if (document.querySelector(".alert-message__container")) {
            height = 90 + document.querySelector(".alert-message__container").clientHeight;
        } 

        if (collectionFilters) {
            collectionFilters.style.top = height + "px";
        } 

        if (collectionBreadcrumbs) {
            collectionBreadcrumbs.style.top = height + "px";
        } 
        
    }


}

customElements.define('collection-filters', CollectionFilters);






class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
      this.setMinAndMaxValues();
    }
  
    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  
    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));
  
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }
  
  customElements.define('price-range', PriceRange);






  /**
 * Price Range slider
 * 
 * @module price-range-slider
 * @version 1.0.0
 * @requires module:collection-filters
 * @extends HTMLElement
 */
 class PriceRangeSlider extends HTMLElement {

    /**
     * Price Ranger Slider web component.
     * 
     * @constructor
     */
    constructor() {
        super();
        this.initEvents();
    }

    /**
       * Init component events.
       * 
       * @returns {undefined}
       */
    initEvents() {

        let element = document.createElement('div');
        this.append(element);

        let step = this.dataset.priceRangeSlideStep || 1;
        let min = this.dataset.priceRangeSlideMin || 0;
        let max = this.dataset.priceRangeSlideMax || 100;
        let inputMin = document.querySelector(this.dataset.inputMinId);
        let inputMax = document.querySelector(this.dataset.inputMaxId);
        let startMin, startMax;
        this.filterInputs = document.querySelectorAll(this.dataset.inputMinId +' , '+ this.dataset.inputMaxId);

        if(inputMin.value && inputMax.value) {
            startMin = inputMin.value;
            startMax = inputMax.value;
        }
        else {
            startMin = min;
            startMax = max;
        }

        // Init noUiSlider
        noUiSlider.create(element, {
            start: [startMin, startMax],
            connect: true,
            step: Number(step),
            range: {
                'min': Number(min),
                'max': Number(max)
            },
            handleAttributes: [
              { 'aria-label': 'Lower price' },
              { 'aria-label': 'Upper price' },
            ]

        });

        this.filterInputs.forEach((input, indexInput) => { 
            input.addEventListener('input', () => {
                element.noUiSlider.setHandle(indexInput, input.value);
            })
        });

        element.noUiSlider.on('update', (values, handle) => {
            this.filterInputs[handle].value = values[handle];
        });

        // Dispatch Input event after value is updated
        element.noUiSlider.on('set', (values, handle) => { 

            var event = new Event('input', {
                bubbles: true,
                cancelable: true,
            });

            if((parseInt(inputMin.value) == parseInt(min))&&(parseInt(inputMax.value) == parseInt(max))) {
                inputMin.removeAttribute('name');
                inputMax.removeAttribute('name');
            }else {
                inputMin.setAttribute('name', 'filter.v.price.gte');
                inputMax.setAttribute('name', 'filter.v.price.lte');
            }
            
            this.filterInputs[handle].dispatchEvent(event);

        });

        window.addEventListener('load', () => {
            const queryString = window.location.search;
            if((queryString.includes('filter.v.price.gte'))||(queryString.includes('filter.v.price.lte'))){
                inputMin.setAttribute('name', 'filter.v.price.gte');
                inputMax.setAttribute('name', 'filter.v.price.lte');
            }else{
                inputMin.removeAttribute('name');
                inputMax.removeAttribute('name');
            }
        });

    }
}

customElements.define('price-range-slider', PriceRangeSlider);





/**
 * Facet remove
 * 
 * @module facet-remove
 * @version 1.0.0
 * @requires module:collection-filters
 * @extends HTMLElement
 */
 class FacetRemove extends HTMLElement {

    /**
     * Facet remove filters web component.
     * 
     * @constructor
     */
    constructor() {

        super();

        this.querySelector('a').addEventListener('click', (event) => {

            event.preventDefault();

            const form = this.closest('collection-filters') || document.querySelector('collection-filters');

            form.onActiveFilterClick(event);
        });
    }
}

customElements.define('facet-remove', FacetRemove);
